import React from 'react';
import { LockOutlined } from '@ant-design/icons';
import { TextBox } from 'components/form/TextBox/index';
import './SSNField.scss';
import classnames from 'classnames';

const SSNField = props => {
  const {
    ssn,
    setSsn,
    requiredSsnCharaters,
    className,
    fieldClassName,
    innerLabel,
  } = props;
  const placeholder = props.placeholder
    ? props.placeholder
    : props.fullSsn
    ? '9-Digit SSN'
    : 'Last 4 digits of SSN';
  const customClassName = classnames(className);
  const fieldCustomClassName = classnames('ssn-inline', fieldClassName);

  if (props.fullSsn) {
    return (
      <div className={`SSNField fullSsn ${customClassName}`}>
        {!props.hideLock && (
          <>
            <LockOutlined />
            <span className="ssnPadder" />
          </>
        )}
        <TextBox
          outerClassName={fieldCustomClassName}
          placeholder={placeholder}
          value={ssn?.label}
          onChange={setSsn}
          maxLength={requiredSsnCharaters}
          type="tel"
          autoFocus={props?.autofocus}
          error={props?.error}
        />
      </div>
    );
  } else {
    if (innerLabel) {
      return (
        <div className={`SSNField ${customClassName}`}>
          {!props.hideLock && (
            <>
              <LockOutlined />
            </>
          )}
          <span className="ssnPadder" />
          <span className="x-prefix">***-**-</span>
          <span className="ssnPadder" />
          <TextBox
            outerClassName={fieldCustomClassName}
            placeholder={placeholder}
            value={ssn?.label}
            onChange={setSsn}
            type="tel"
            maxLength={requiredSsnCharaters}
            autoFocus={props?.autofocus}
            error={props?.error}
            fullWidth={true}
          ></TextBox>
        </div>
      );
    } else {
      return (
        <div className={`SSNField ${customClassName}`}>
          {!props.hideLock && (
            <>
              <LockOutlined />
            </>
          )}
          <span className="ssnPadder" />
          <span className="x-prefix">XXX - XX - </span>
          <span className="ssnPadder" />
          <TextBox
            outerClassName={fieldCustomClassName}
            placeholder={placeholder}
            value={ssn?.label}
            onChange={setSsn}
            type="tel"
            maxLength={requiredSsnCharaters}
            autoFocus={props?.autofocus}
            error={props?.error}
          />
        </div>
      );
    }
  }
};

export default SSNField;
